export const Device = {
  Tablet: '768px',
  MobileS: '320px',
  MobileM: '375px',
  MobileL: '425px',
};

export const BCA_TERMS =
  'https://www.vodacombusiness.co.za/sites/vodacombusinesscoza/files/media/documents/pdf/vodalend-merchant-agreement-2.pdf';

export const downloadToPUrl =
  'https://play.google.com/store/apps/details?id=za.co.synthesis.halo.mpos.vodacom&hl=en_US&utm_source=Buy%20POS%20Website&utm_medium=Web%20Journey&utm_campaign=Lets%20get%20started';

export const publicSiteUrl =
  'https://www.vodacombusiness.co.za/business/solutions/financial-services/e-commerce';

export const vfsHomeUrl = 'https://www.vodacombusiness.co.za/business/solutions/financial-services';

export const bcaContractTermsAndConditionsUrl =
  'https://www.vodacombusiness.co.za/sites/vodacombusinesscoza/files/media/documents/pdf/vodalend-merchant-agreement-03.pdf';

export const vodalendDigitalTerms =
  'https://www.vodacombusiness.co.za/sites/vodacombusinesscoza/files/media/documents/terms-and-conditions/vodacom-merchant-agreement.pdf ';

export const merchantAgreementTerms =
  'https://www.vodacombusiness.co.za/sites/vodacombusinesscoza/files/media/documents/terms-and-conditions/vodacom-merchant-agreement.pdf';

export const merchantAgreementMiniAppURL =
  'https://vodapay.vodacom.co.za/vodapay/terms/vodacom-merchant-agreement';

export const moreInfoForFundingURL =
  'https://www.vodacombusiness.co.za/business/solutions/fund-my-business';

export const applyForFundingURL = 'https://vodalend.vodacombusiness.co.za/GetStarted?cid=undefined';

export const fundMyNextUrl = 'https://vodalend.vodacombusiness.co.za/GetStarted';
export const fundMyNextReadMoreUrl =
  'https://www.vodacombusiness.co.za/business/solutions/fund-my-business';

export const contacts = {
  number: '011 066 0847',
  numberUrl: 'tel:0110660847',
  email: 'sinawe@vodacom.co.za',
  emailUrl: 'mailto:sinawe@vodacom.co.za',
};

export const provinces = [
  'Eastern Cape',
  'Free State',
  'Gauteng',
  'KwaZulu-Natal',
  'Limpopo',
  'Mpumalanga',
  'Northern Cape',
  'North West',
  'Western Cape',
];

export const RETRY_ATTEMPT = 3;

export const MAX_NUMBER_OF_TRIES = 3;

export const COMPANY_PLACEHOLDER = 'company placeholder';

export const xLinkContacts = {
  number: '080 000 0654',
  numberUrl: 'tel:0800000654',
  email: 'VPS@xlink.co.za',
  emailUrl: 'mailto:VPS@xlink.co.za',
  whatsapp: '072 605 9421',
  whatsappUrl: 'https://wa.me/27726059421',
};

export const privacyNoticeUrl =
  'https://www.vodacom.co.za/vodacom/terms/privacy-policy/payment-services';

// Salesforce only allows the date picker to select a date from the year 1700 and up.
export const MIN_DATE_ALLOWED = new Date('01/01/1700');

export const DEBUG_CONFIG_KEY = 'debugConfig';
export const DEV_TOOLS_KEY = 'devTools';

export const TITLES = ['Mr', 'Mrs', 'Miss', 'Dr', 'Prof'];
export const CREDIT_VETTING_TITLES = ['Mr', 'Mrs', 'Miss', 'Dr'];
export const tapOnPhoneSessionKey = 'tap_on_phone_journey';

export type BCATermsItem = {
  title: string;
  children?: BCATermsItem[];
  subtitle?: string;
};

// Used for VPG
export const selfOnboardingSalesOrg = 'VodacomPaymentServices';
